import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="border-t border-border mt-auto w-full max-w-full overflow-x-hidden">
      <div className="container mx-auto px-4 py-6 w-full">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p className="text-center md:text-left">
            © {new Date().getFullYear()} Dino. All rights reserved.
          </p>
          <nav className="flex flex-wrap justify-center gap-6">
            <Link 
              to="/community-guidelines" 
              className="hover:text-foreground transition-colors"
            >
              Community Guidelines
            </Link>
            <Link 
              to="/terms-of-service" 
              className="hover:text-foreground transition-colors"
            >
              Terms of Service
            </Link>
            <Link 
              to="/privacy-policy" 
              className="hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
